export class DestaqueProduto {
    constructor(id = 0, titulo = ''
        //, produtoId = 0, produto = null
    ) {
        this.id = id;
        this.titulo = titulo;
        //this.produtoId = produtoId;
        //this.produto = produto;
    }
}
